import { Box, Grid, Typography } from "@mui/material";
import React from "react";

interface IFormContent {
  title?: string;
}

const FormContent: React.FC<IFormContent> = (props) => {
  const { title, children } = props;
  return (
    <Box sx={{ mb: 4 }}>
      {title && (
        <Typography
          variant="h4"
          sx={{ paddingBottom: "16px" }}
          fontWeight={"700"}
        >
          {title}
        </Typography>
      )}
      <Grid container columnSpacing={2} rowSpacing={2}>
        {children}
      </Grid>
    </Box>
  );
};

export default FormContent;
